import {State} from '@synako/halitrek';
import {ArticleDesc, SuggestionsStateDesc} from 'api-types/ffconnect-hal';
import {TemperatureLivraison1} from 'api-types/ffconnect';

// frequency : met en avant les articles avec suggestions de quantité
// alphabetic : tri par libellé commercial
export type SortType = 'alphabetic' | 'frequency';

export interface CadencierArticle {
  code: string;
  temperature_livraison?: TemperatureLivraison1;
  libelle_commercial?: string;
  articleState?: State<ArticleDesc>;
}

export const TriArticlesCadencier = (
  articles: CadencierArticle[],
  sortType: SortType,
  suggestionsState?: State<SuggestionsStateDesc>,
): CadencierArticle[] => {
  // Si le tri par fréquence est demandé et que les suggestions sont disponibles
  if (sortType === 'frequency' && suggestionsState?.data.suggestions) {
    const suggestions = suggestionsState.data.suggestions;
    const articlesCopy = [...articles];

    return articlesCopy.sort((a, b) => {
      const hasSuggestionA = suggestions.some((s) => s.code_article === a.code);
      const hasSuggestionB = suggestions.some((s) => s.code_article === b.code);

      // Si un article a une suggestion et l'autre non, on le met en premier
      if (hasSuggestionA !== hasSuggestionB) {
        return hasSuggestionB ? 1 : -1;
      }
      return 0;
    });
  }

  // Sinon, on garde l'ordre original
  return articles;
};
